'use client';

import * as React from 'react';
/**
 * @ignore - internal component.
 */
export const ChartContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") ChartContext.displayName = "ChartContext";